import { DataTransferStage } from '@/API';
import { GraphQLOptionsV6 } from '@aws-amplify/api-graphql';
import { GenericRepository } from '@/repository/GenericRepository.ts';
import * as queries from '@/graphql/queries.ts';

export class DataTransferJobRepository extends GenericRepository<DataTransferStage> {
  constructor() {
    super();
  }

  async list(options?: GraphQLOptionsV6['variables']) {
    return (
      await this.client.graphql({
        query: queries.listDataTransferStages,
        variables: options,
      })
    ).data.listDataTransferStages;
  }
}
